exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3jsho{display:-webkit-box;display:-ms-flexbox;display:flex;position:relative;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:5px 0;font-weight:600;font-size:13px;z-index:100}._12AGs{padding:5px 10px;border:1px solid #ffc107;border-bottom-left-radius:2px;border-top-left-radius:2px}._3-yjN{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;text-align:center}._2VNG9{background-color:#fbd60b;border-bottom-right-radius:2px;border-top-right-radius:2px}", ""]);

// exports
exports.locals = {
	"root": "_3jsho",
	"info": "_12AGs",
	"desktopInfo": "_3-yjN",
	"infoPercent": "_2VNG9"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/Discount/Discount.css
// module id = 1931
// module chunks = 18 19 32 36 37